module.exports = __webpack_public_path__ + "img/YES CHAIN.e96d154a.svg";